import { Injectable } from '@angular/core';
// import { Auth, user } from '@angular/fire/auth';
import { Auth, user } from '@angular/fire/auth';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProfileDetailsModel, ProfileModel } from '../models/profile.model';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';
 
@Injectable({
  providedIn: 'root',
})

export class ViewerDetailsResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private homeService:HomeService, private auth:Auth) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    const currentUser = await firstValueFrom(user(this.auth));
    // console.log('viewer resolver current user',currentUser);
    if(currentUser){
      const idTokenResult = await currentUser.getIdTokenResult();
      // console.log('get role user',idTokenResult);
      const role = idTokenResult.claims.role ;
      // console.log(role);
      const item = await firstValueFrom(this.dataService.getProfileDetails(currentUser.uid, role));
      if(Object.keys(item).length>0 && role!=='anonymous'){
        return this.returnProfile(item,currentUser.uid,role)
      }
      else{
        return this.returnNewProfile(role);
      }  
    }
    else{
      return this.returnNewProfile('consumer');
    }
  };

    // return user(this.auth).pipe(
    //   take(1),
    //   map(user => {
    //     console.log('user',user);
    //     let item = {};
    //     const role = user['role'];
    //     if(user){
    //       this.dataService.getProfileDetails(user.uid, role).pipe(take(1)).subscribe(item => {
    //         if(Object.keys(item).length>0 && role!=='anonymous'){
    //         return this.returnProfile(item,user.uid,role)
    //         }
    //         else{
    //           return this.returnNewProfile(role);
    //         }     
    //       });
    //     }
    //     else{
    //       return this.returnNewProfile('anonymous');
    //     }
    //   })
    // );


  returnProfile(item:ProfileDetailsModel,id:string,role:string):ProfileModel{
    const profile:ProfileModel = {
      key:id,
      role:role,
      details:item
    }
    return (profile);
  }

  returnNewProfile(role:string):ProfileModel{
    const newProfile = <ProfileModel>{
      status:'new',
      role:role,
      details:{
        role:role,
        geocoding:{
          address:{
            postalCode:null,
            countryCode:null,
            city:null,
            houseNumber:null,
          }
        },
        fullProfile:false,
        shortDetails:{
          name:null
        },
        fullDetails:{
          firstname:null,
          lastname:null,
          phone:null
        }
      },
      private:{
        notifications:{
          newTournee:{
            email:true,
            app:true,
          }
        }
      }
    };
    return (newProfile);
  }
}